// ** Navigation imports
import apps from "./apps";
import pages from "./pages";
import forms from "./forms";
import tables from "./tables";
import others from "./others";
import charts from "./charts";
import dashboards from "./dashboards";
import uiElements from "./ui-elements";
import ciro from "./ciro";
import users from "./users";
import sales from "./sales";
import refunds from "./refunds";
import changelog from "./changelog";

import products from "./products";
import api from "./api";
import onaylar from "./onaylar";
import risk from "./risks";
import referans from "./referans";
import kuponlar from "./kuponlar";
import onboarding from "./onboarding";
import pfConfig from "./pfConfig";
import region from "./region";

import hataMesaj from "./hataMesaj";
import demo from "./demo";
import subscription from "./subscription";

// ** Merge & Export
export default [
  ...users,
  ...sales,
  ...refunds,
  ...products,
  ...subscription,
  ...ciro,
  ...referans,
  // ...kuponlar,
  ...risk,
  ...onboarding,
  ...pfConfig,
  ...region,
  ...changelog,
  // ...api,
  // ...onaylar,
  // ...hataMesaj,
  // ...apps,
  // ...pages,
  // ...demo,
  // ...uiElements,
  // ...forms,
  // ...tables,
  // ...charts,
  // ...others,
  // ...dashboards,
];
